import { render, staticRenderFns } from "./earth.vue?vue&type=template&id=3497d806&scoped=true&"
import script from "./earth.vue?vue&type=script&lang=js&"
export * from "./earth.vue?vue&type=script&lang=js&"
import style0 from "./earth.vue?vue&type=style&index=0&id=3497d806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3497d806",
  null
  
)

export default component.exports